import { getAbbreviatedMonthInPtbr } from './get-abbreviated-month-in-ptbr';
import { getYear } from './get-year';

export const displayCycleInfoDashboard = ({
  cycleCod,
  cycleBegin,
  cycleEnd,
}) => {
  const cycle = cycleCod;

  const cycleEndDate = `${getAbbreviatedMonthInPtbr(
    cycleBegin
  )}-${getAbbreviatedMonthInPtbr(cycleEnd)}-${getYear(cycleEnd)}`;

  const openCycle = `${getAbbreviatedMonthInPtbr(cycleBegin)}-ativo`;

  const returnsWhetherTheCycleHasFinishedorNot = cycleEnd
    ? cycleEndDate
    : openCycle;

  const cycleLabel = 'Ciclo';
  return `${cycleLabel} ${cycle} (${returnsWhetherTheCycleHasFinishedorNot})`;
};
